// ── Action type constants ──────────────────────────────────────────────────────

export const STARK_LOGS_LIST          = 'STARK_LOGS_LIST';
export const STARK_LOG_GET            = 'STARK_LOG_GET';
export const STARK_LOG_CREATE         = 'STARK_LOG_CREATE';
export const STARK_LOG_UPDATE         = 'STARK_LOG_UPDATE';
export const STARK_LOG_DELETE         = 'STARK_LOG_DELETE';
export const STARK_LOGS_BY_NOTE       = 'STARK_LOGS_BY_NOTE';
export const STARK_PROVIDER_TOTALS    = 'STARK_PROVIDER_TOTALS';
export const STARK_INVALIDATE         = 'STARK_INVALIDATE';

// ── Provider totals ───────────────────────────────────────────────────────────

export const getStarkProviderTotals = (clientId, year, filterUserId) => ({
  type: STARK_PROVIDER_TOTALS,
  request: {
    url: '/v2/stark/totals',
    method: 'GET',
    params: {
      clientId,
      ...(year         != null ? { year }         : {}),
      ...(filterUserId != null ? { filterUserId } : {}),
    },
  },
});

// ── List logs ──────────────────────────────────────────────────────────────────

/**
 * @param {number}   clientId
 * @param {object}   [opts]
 * @param {number}   [opts.year]           - calendar year (falls back to current year if no date range)
 * @param {number}   [opts.filterUserId]   - single-user filter (legacy)
 * @param {string}   [opts.startDate]      - ISO date string from sessionStorage
 * @param {string}   [opts.endDate]        - ISO date string from sessionStorage
 * @param {number[]} [opts.filterUserIds]  - multi-user filter (from user-chip bar)
 */
export const listStarkLogs = (clientId, { year, filterUserId, startDate, endDate, filterUserIds, filterProviderId } = {}) => ({
  type: STARK_LOGS_LIST,
  request: {
    url: '/v2/stark/logs',
    method: 'GET',
    params: {
      clientId,
      ...(year             != null ? { year }             : {}),
      ...(filterUserId     != null ? { filterUserId }     : {}),
      ...(startDate        != null ? { startDate }        : {}),
      ...(endDate          != null ? { endDate }          : {}),
      ...(filterUserIds    && filterUserIds.length > 0
        ? { filterUserIds: filterUserIds.join(',') }      : {}),
      ...(filterProviderId != null ? { filterProviderId } : {}),
    },
  },
});

// ── Logs by activity note ──────────────────────────────────────────────────────

export const listStarkLogsByNote = (activityNoteId) => ({
  type: STARK_LOGS_BY_NOTE,
  noteId: activityNoteId,
  request: {
    url: `/v2/stark/by-note/${activityNoteId}`,
    method: 'GET',
  },
});

// ── Get single log ─────────────────────────────────────────────────────────────

export const getStarkLog = (id) => ({
  type: STARK_LOG_GET,
  id,
  request: {
    url: `/v2/stark/logs/${id}`,
    method: 'GET',
  },
});

// ── Create log ─────────────────────────────────────────────────────────────────

export const createStarkLog = (clientId, data) => ({
  type: STARK_LOG_CREATE,
  request: {
    url: '/v2/stark/logs',
    method: 'POST',
    params: { clientId },
    data,
  },
});

// ── Update log ─────────────────────────────────────────────────────────────────

export const updateStarkLog = (id, data) => ({
  type: STARK_LOG_UPDATE,
  id,
  request: {
    url: `/v2/stark/logs/${id}`,
    method: 'PUT',
    data,
  },
});

// ── Delete log ─────────────────────────────────────────────────────────────────

export const deleteStarkLog = (id) => ({
  type: STARK_LOG_DELETE,
  id,
  request: {
    url: `/v2/stark/logs/${id}`,
    method: 'DELETE',
  },
});

// ── Invalidate cache ───────────────────────────────────────────────────────────
// Dispatch after saving a note that contains stark entries so that any mounted
// StarkTrackingPage re-fetches its tables.
export const invalidateStark = () => ({ type: STARK_INVALIDATE });

// ── CSV export ─────────────────────────────────────────────────────────────────
// Handled directly via axiosInstance in the component (blob download).
